module.exports = __webpack_public_path__ + "static/media/pc-success.d8d0a5d8.svg";